module.exports = __webpack_public_path__ + "static/img/slide.2428d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/slide.png
// module id = tW6a
// module chunks = 1